import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    props: {
        chatter:Object,
        // title: String,
        // likes: Number,
        // isPublished: Boolean,
        // commentIds: Array,
        // author: Object,
        // callback: Function,
        // contactsPromise: Promise // or any other constructor
    },
    watch: { 
        chatter: function(newVal, oldVal) { // watch this prop
            this.set_chat_view = false; //reload
            this.chat_log = []; //reload
            this.getChatLogs();
           // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        }
    },
    data () {
        return {
            user:{},
            chat:{},
            // chatter:{},
            chat_logs:{},
            chat_log:{},
            active_chat:{},
            disable_btn: false,
            loggedIn: false,
            loading: true,
            action_loading:{},
            menu_tab_view:{},
            set_chat_view:false,
            style1: {
                margin:'0.6em 0', 
                borderRadius: '1em',
                border:'#e6e3e3 solid',
                padding:'0.5em',
                width:'85%',
                textAlign: 'left',
                float: 'right',
            },
            style2: {
                margin:'0.6em 0', 
                borderRadius: '1em',
                border:'#e6e3e3 solid',
                padding:'0.5em',
                width:'85%',
                textAlign: 'left',
                float: 'left',
            }
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setChatStyle(chat){
            if(this.chatter.chatter_chat_from == chat.chat_from){
                return this.style1;
            }else{
                return this.style2;
            }
        },

        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                this.setComponent('reset-edit','');
            }else{
                this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },

        preset_xtra() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                           this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        preset() {
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.getChatLogs();//run first
                    // self.getChatLog(self.user.user_id);//run first
                    setTimeout(function(){ 
                        self.loadChatLogs();
                    }, 30000);
                    // self.getChatLogs();

                    self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
        },
        
        loadChatLogs(){
            let self = this;
            setInterval(function(){
                self.getChatLogs();
            }, 30000);
            // if(self.edit_mode){
            //     setInterval(function(){
            //         self.getChatLogs();
            //     }, 30000);
            // }else{
            //     setInterval(function(){
            //         self.getChatLog(self.user.user_id);
            //     }, 30000);
            // }
        },

        loadCurrentChatLog(ini){ //redo
            let self = this;
            setInterval(function(){
                self.getChatLog(ini)
                // service.getChatLog(self, self.chatter.id, ini).then(response => {
                //     if(response.body.status == 200) { 
                //         self.chat_log = response.body.data;
                //     }
                // }).catch((err) => {
                //     self.loading = false;
                // })
            }, 10000);
        },

        setChatLog(chatlog){
            // this.active_chat.chat_to = chatlog.chat_to;
            // this.active_chat.chat_ini = chatlog.chat_from; //chat_to;

            //set some params
            if((Object.keys(chatlog).length != 0)){ //not //new //or empty chat
                if(chatlog.chatlog_from_to_module == 20){ //ie group chat
                    this.chatter.chatter_chat_group = chatlog.chatlog_from_to;
                    this.chatter.chatter_chat_to = chatlog.chatlog_from_to; //group id
                    this.chatter.chatter_chat_to_module = 20; //group module
                }else{
                    this.chatter.chatter_chat_group = 0;
                    this.chatter.chatter_chat_to = chatlog.chatlog_from_to; //chat to the sender
                    this.chatter.chatter_chat_to_module = chatlog.chatlog_from_to_module; //chat to the sender module
                }
            }
            
            this.chat_log = chatlog;
            this.set_chat_view = true;
            this.loadCurrentChatLog(chatlog.chat_ref); //redo
        },

        getChatLogs(){
            // this.loading = true;
            service.getChatLogs(this, this.chatter.chatter_chat_from_module, this.chatter.chatter_chat_from).then(response => {
                if(response.body.status == 200) { 
                    this.chat_logs = response.body.data;
                    //set active chat log
                    if(this.chatter.chatter_set_active_chat != 0){
                        for(let chat_log of this.chat_logs){
                            if(this.chatter.chatter_set_active_chat == chat_log.chatlog_ref){
                                this.chat_log = chat_log;
                                this.set_chat_view = true;
                                this.setChatLog(this.chat_log);
                            }
                        }
                        this.set_chat_view = true;
                        //if no match //set as new
                        if((Object.keys(this.chat_log).length === 0)){ 
                            this.chat_log = [];
                            this.setChatLog(this.chat_log);
                        }
                    }
                }
                // this.loading = false;
            }).catch((err) => {
                // this.loading = false;
            })
        },

        getChatLog(ini){ //btn sp and initiator
            // this.loading = true; 
            for(let chat_log of this.chat_logs){
                if(this.chat_log.chatlog_ref == chat_log.chatlog_ref){
                    this.set_chat_view = true;
                    this.chat_log = chat_log;
                }
            }
            // service.getChatLog(this, this.chatter.chatter_chat_from_module, this.chatter.chatter_chat_from, ini).then(response => {
            //     if(response.body.status == 200) { 
            //         this.chat_log = response.body.data;
            //     }
            //     this.loading = false;
            // }).catch((err) => {
            //     this.loading = false;
            // })
        },

        postChatObject(product){
            this.chat.chat_message_type = 8;
            this.chat.chat_message_object = product.product_id;
            this.chat.chat_message_object_product_name = product.product_name;
            this.chat.chat_message_object_product_price = product.product_items[0].product_item_price_f;
            this.chat.chat_message_object_product_url_name = product.product_url_name;
            this.chat.chat_message_object_product_image = product.product_images[0].product_image;
            this.postChat();
        },

        postChat(){
            this.chat.chat_message = this.chat.chat_set_message;
            this.chat.chat_set_message = ""; //free text field
            this.activate_processing();
           
            var payload = {
                chat_module: this.chatter.chatter_chat_from_module, 
                chat_module_id: this.chatter.chatter_chat_from,
                chat_ini: this.chatter.chatter_chat_from,
                chat_type: 0,
                chat_from: this.chatter.chatter_chat_from,
                chat_from_point_module: this.chatter.chatter_chat_from_module, 
                chat_to: this.chatter.chatter_chat_to,
                chat_to_point_module: this.chatter.chatter_chat_to_module,
                chat_group: this.chatter.chatter_chat_group || 0,
                chat_message: this.chat.chat_message || "",
                chat_message_type: this.chat.chat_message_type || 0,
                chat_message_object: this.chat.chat_message_object || 0,
                chat_message_object_product_name: this.chat.chat_message_object_product_name || "",
                chat_message_object_product_price: this.chat.chat_message_object_product_price || 0,
                chat_message_object_product_url_name: this.chat.chat_message_object_product_url_name || "",
                chat_message_object_product_image: this.chat.chat_message_object_product_image || "",
            }
            // (payload.chat_message == undefined) || (payload.chat_message == "") && 
            if(((payload.chat_message == "") && (payload.chat_message_object == 0))){
                this.data_processing_message = "Nothing Sent";
                this.deactivate_processing();
            }else{
                service.postChat(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        // this.chat_log = data.body.data;
                        //#below //use for now //recheck
                        this.chatter.chatter_set_active_chat = this.chatter.chatter_chat_from.concat(this.chatter.chatter_chat_from_module).concat(this.chatter.chatter_chat_to).concat(this.chatter.chatter_chat_to_module)
                        this.chat = {}; //reload
                        this.getChatLogs(); //use for now
                        // this.chat_logs = data.body.data;
                        // this.loadCurrentChatLog(this.chatter.chatter_chat_from);
                        this.setMenuTabView("");
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    //log it
                    this.delivery_option = {};
                    this.deactivate_processing();
                })
            }
        },

        
    },
    created: function(){
        //console.log(this.chatter)
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Chat/script.js